// ======================================================================
// File Name       : ServiceGroupConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from './ModalIds';

export const REDIRECT_MODAL = {
  [ModalIds.SERVICE_GROUP_DETAIL]: {
    OK: ModalIds.SERVICE_GROUP_REGISTER_EDIT,
  },
  [ModalIds.SERVICE_GROUP_REGISTER_EDIT]: {
    OK: ModalIds.SERVICE_GROUP_EDIT_SERVICE,
  },
  [ModalIds.SERVICE_GROUP_EDIT_SERVICE]: {
    OK: ModalIds.SERVICE_GROUP_EDIT_SUPERUSER,
    CANCEL: ModalIds.SERVICE_GROUP_REGISTER_EDIT,
  },
  [ModalIds.SERVICE_GROUP_EDIT_SUPERUSER]: {
    OK: ModalIds.SERVICE_GROUP_CONFIRM,
    CANCEL: ModalIds.SERVICE_GROUP_EDIT_SERVICE,
  },
  [ModalIds.SERVICE_GROUP_CONFIRM]: {
    CANCEL: ModalIds.SERVICE_GROUP_EDIT_SUPERUSER,
    ERROR: ModalIds.SERVICE_GROUP_REGISTER_EDIT,
  },
};
